<template>
  <!-- Modal -->
  <div class="modal fade" id="CostBudgetChangeModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('budget.domestic_shipping_fee') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <input type="text" min-value="0" class="form-control" :placeholder="costPlaceholder" v-model="tempCost.cost">
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>
          <button type="button" class="btn btn-primary" @click="updateBudget()">{{ translations('common.update') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CostBudgetChangeModal',
  props: {
    vat: {}, // VAT
    cost: {}
  },
  data () {
    return {
      tempCost: {},
      costPlaceholder: 0
    }
  },
  watch: {
    cost: {
      handler (value) {
        this.tempCost = value
        this.costPlaceholder = value.cost
      }
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    filterTax (target, taxIncluded = null, vatRate = null) { // VAT INPUT @Modal
      target = target || 0
      taxIncluded = taxIncluded === null ? this.$props.vat.taxIncluded : taxIncluded
      vatRate = vatRate === null ? Number(this.$props.vat.vatRate) : Number(vatRate)
      if (!taxIncluded) {
        return target
      } else {
        let noTax = Math.round(target / ((100 + vatRate) / 100))
        return noTax
      }
    },
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    updateBudget () {
      this.tempCost.cost = this.filterTax(this.tempCost.cost) // VAT INPUT @Modal
      this.$parent.updateBudgetCost(this.tempCost)
      this.$refs['closeModal'].click()
    }
  }
}
</script>
